export const LOCALE_PREFIX = 'components.Tooltips.Indicators.DistraintsTooltip'
